var moduleMap = {
	"./AppExport": function() {
		return Promise.all([__webpack_require__.e(7718), __webpack_require__.e(7406), __webpack_require__.e(9872), __webpack_require__.e(9001), __webpack_require__.e(975), __webpack_require__.e(1257), __webpack_require__.e(6985)]).then(function() { return function() { return (__webpack_require__(66985)); }; });
	},
	"./AppExportMF": function() {
		return Promise.all([__webpack_require__.e(8872), __webpack_require__.e(6305), __webpack_require__.e(9309), __webpack_require__.e(2808), __webpack_require__.e(7718), __webpack_require__.e(7406), __webpack_require__.e(9872), __webpack_require__.e(9001), __webpack_require__.e(975), __webpack_require__.e(1257), __webpack_require__.e(3854), __webpack_require__.e(8478), __webpack_require__.e(9229)]).then(function() { return function() { return (__webpack_require__(32439)); }; });
	},
	"./ReportExport": function() {
		return Promise.all([__webpack_require__.e(8872), __webpack_require__.e(6305), __webpack_require__.e(7718), __webpack_require__.e(7406), __webpack_require__.e(9872), __webpack_require__.e(9001), __webpack_require__.e(975), __webpack_require__.e(3854), __webpack_require__.e(9100)]).then(function() { return function() { return (__webpack_require__(75113)); }; });
	},
	"./OrderManagement": function() {
		return Promise.all([__webpack_require__.e(8872), __webpack_require__.e(6305), __webpack_require__.e(9309), __webpack_require__.e(9057), __webpack_require__.e(7718), __webpack_require__.e(4935), __webpack_require__.e(7406), __webpack_require__.e(9001), __webpack_require__.e(3851), __webpack_require__.e(7202), __webpack_require__.e(975), __webpack_require__.e(958), __webpack_require__.e(5987)]).then(function() { return function() { return (__webpack_require__(55987)); }; });
	},
	"./Payment": function() {
		return Promise.all([__webpack_require__.e(8872), __webpack_require__.e(9309), __webpack_require__.e(9057), __webpack_require__.e(7718), __webpack_require__.e(7406), __webpack_require__.e(9872), __webpack_require__.e(9001), __webpack_require__.e(3851), __webpack_require__.e(7202), __webpack_require__.e(975), __webpack_require__.e(958), __webpack_require__.e(1257), __webpack_require__.e(6872)]).then(function() { return function() { return (__webpack_require__(27508)); }; });
	},
	"./OrderReport": function() {
		return Promise.all([__webpack_require__.e(8872), __webpack_require__.e(6305), __webpack_require__.e(9309), __webpack_require__.e(9057), __webpack_require__.e(7718), __webpack_require__.e(7406), __webpack_require__.e(9872), __webpack_require__.e(6131), __webpack_require__.e(9001), __webpack_require__.e(3851), __webpack_require__.e(975), __webpack_require__.e(3743), __webpack_require__.e(4572), __webpack_require__.e(7062)]).then(function() { return function() { return (__webpack_require__(97062)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});